import template from './sw-cms-block-form.html.twig';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
